module.exports = __webpack_public_path__ + "img/google-maps.6bafda45.svg";